/**
 * `/content-preview/:id` — full-page draft preview opened in a new tab from the page builder's
 * "Preview" button. Top-level route (no admin shell) so it looks like the public site; the
 * `…/preview` API it calls still enforces platform authorization.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ContentPreviewPage } from '../features/content';

export const Route = createFileRoute('/content-preview/$id')({
  component: function ContentPreviewRoute() {
    const { id } = Route.useParams();
    return <ContentPreviewPage id={id} />;
  },
});
